<div id="investment-card" >
    <div class="tick-container  animate__animated animate__bounceIn" *ngIf="investmentOption.percentage === 100" appanimatecss>
        <div class="tick"><mat-icon>check</mat-icon></div>
    </div>
    <!-- if theres an investment option fill out the card with data -->
    <ng-container *ngIf="investmentOption">
        <div class="d-flex flex-column justify-content-between h-100">
            <div class="d-flex flex-column">
                <div class="investment-header">
                    {{investmentOption.optionName}}
                </div>
                <div class="investment-subheader">{{investmentOption.optionDescription}}</div>

            </div>

            <div class="d-flex flex-column">
                <div class="card-row" *ngIf="investmentOption.optionRiskBand">
                    <div class="card-row-title">Risk Band</div>
                    <div class="card-row-detail">{{investmentOption.optionRiskBand}}</div>
                    <div class="card-row-tooltip"><app-investment-tooltip
                            [tooltipText]="riskTooltip"></app-investment-tooltip></div>
                </div>
                <div class="card-row" *ngIf="investmentOption.optionTimeframe">
                    <div class="card-row-title">Timeframe</div>
                    <div class="card-row-detail">{{investmentOption.optionTimeframe}}</div>
                    <div class="card-row-tooltip"><app-investment-tooltip
                            [tooltipText]="timeframeTooltip"></app-investment-tooltip></div>
                </div>
                <div class="card-row" *ngIf="investmentOption.optionFees">
                    <div class="card-row-title">Fees and costs</div>
                    <div class="card-row-detail">{{investmentOption.optionFees}}</div>
                    <div class="card-row-tooltip dagger">&dagger;</div>
                </div>
            </div>
            <app-button [isDisabled]="investmentOption.percentage === 100" class="custom mt-2" title="Select" icon="east" (onClick)="onSelect()"></app-button>

        </div>

    </ng-container>
</div>